var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcShareSolid(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7318 6.05069C13.4138 6.06134 13.3108 6.32046 13.3108 6.68707V12.2871H2.14992V6.68707C2.14992 6.32046 2.10289 6.05069 1.73628 6.05069C1.4181 6.05069 1.33325 6.32046 1.33325 6.68707L1.38628 12.2871C1.38628 12.8981 1.53892 13.1037 2.14992 13.1037H13.3108C13.9218 13.1037 14.1666 12.8981 14.1666 12.287V6.68707C14.1666 6.32046 14.103 6.03825 13.7318 6.05069Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03286 1.01273C7.87754 0.85741 7.62571 0.85741 7.47039 1.01273L5.08402 3.3991C4.9287 3.55442 4.9287 3.80625 5.08402 3.96157C5.23934 4.11689 5.49117 4.11689 5.64649 3.96157L7.38095 2.22508V10.1174C7.38095 10.3316 7.55463 10.5053 7.76887 10.5053C7.98311 10.5053 8.15679 10.3316 8.15679 10.1174V2.25445L9.85676 3.96157C10.0121 4.11689 10.2639 4.11689 10.4192 3.96157C10.5746 3.80625 10.5746 3.55442 10.4192 3.3991L8.03286 1.01273Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShareSolid);
export default __webpack_public_path__ + "static/media/ic-share-solid.79f413aba447f15d83591cd636938b97.svg";
export { ForwardRef as ReactComponent };